<template>
    <div class="footer mt-5 py-3">
        <b-container>

            <b-row class="mt-3">
                <b-col md="9">
                    <ul class="list-unstyled">
                        <li>
                            Clubs Away Limited | Kemp House | 152 - 160 City Road | London | ECIV 2NX 
                        </li>

                        <li class="mt-1">
                            Telephone: <a href="tel:02076897505">0207 689 7505</a> | Email: <a href="mailto:hello@clubsaway.co.uk">hello@clubsaway.co.uk</a>
                        </li>
                    </ul>
                </b-col>

                <b-col>
                    <span>
                        Website design and development by That's Brave
                    </span>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped lang="scss">
    .footer {
        color: white;
        background-color: #384044;

        a {
            color: white;

            &:hover {
                text-decoration: none;
            }
        }
    }
</style>